export { default } from './ListItemText';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/ListItemText/index.js
// module id = 456
// module chunks = 121